import { render, staticRenderFns } from "./DemoVsClients.vue?vue&type=template&id=927e7d06"
import script from "./DemoVsClients.vue?vue&type=script&lang=js"
export * from "./DemoVsClients.vue?vue&type=script&lang=js"
import style0 from "./DemoVsClients.vue?vue&type=style&index=0&id=927e7d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports